import React from 'react';
import { PageWithHeader } from '@backstage/core-components';
import { useApi, configApiRef } from '@backstage/core-plugin-api';

const TechDocsPageWrapper = (props) => {
  const { children } = props;
  const configApi = useApi(configApiRef);
  const generatedSubtitle = `Documentation available in ${configApi.getOptionalString("organization.name") ?? "Backstage"}`;
  return /* @__PURE__ */ React.createElement(
    PageWithHeader,
    {
      title: "Documentation",
      subtitle: generatedSubtitle,
      themeId: "documentation"
    },
    children
  );
};

export { TechDocsPageWrapper };
//# sourceMappingURL=TechDocsPageWrapper.esm.js.map
